import { useState, useEffect } from "react";
import {
  insertCompanyLocation,
  getCompanyLocation,
} from "../../services/dataService";
import Breadcrumb from "../../components/common/Breadcrumb";

function GeneralSettings() {
  const [loading, setLoading] = useState(false);
  const [existingLocation, setExistingLocation] = useState(null);
  const [errors, setErrors] = useState({});

  const [locationData, setLocationData] = useState({
    latitude: "",
    longitude: "",
    allowRadius: "",
    isActive: true,
    autoDeduction: false,

    MaxPermissionLimit: "",
    MinPermissionDuration: "",
    MaxPermissionDuration: "",
  });

  useEffect(() => {
    fetchExistingLocation();
  }, []);

  const fetchExistingLocation = async () => {
    try {
      setLoading(true);

      const response = await getCompanyLocation();

      const locationArray =
        response?.data?.data || response?.data || [];

      if (locationArray.length > 0) {
        const loc = locationArray[0];

        setExistingLocation(loc);

        setLocationData({
          LocationId: loc?.LocationId,

          latitude: loc.Latitude
            ? loc.Latitude.toString()
            : "",

          longitude: loc.Longitude
            ? loc.Longitude.toString()
            : "",

          allowRadius: loc.AllowedRadius
            ? loc.AllowedRadius.toString()
            : "",

          isActive: Boolean(loc.IsActive),

          autoDeduction: Boolean(loc.AutoDeduction),

          MaxPermissionLimit:
            loc.MaxPermissionLimit || "",

          MinPermissionDuration:
            loc.MinPermissionDuration || "",

          MaxPermissionDuration:
            loc.MaxPermissionDuration || "",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // HH:MM validation
  const isValidTimeFormat = (value) => {
    return /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])$/.test(
      value
    );
  };

  const handleLocationChange = (e) => {
    const { name, value, type, checked } = e.target;

    setLocationData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Validation
    if (
      [
        "MinPermissionDuration",
        "MaxPermissionDuration",
      ].includes(name)
    ) {
      if (value && !isValidTimeFormat(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Enter valid HH:MM format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
  };

  const handleSubmitLocation = async (e) => {
    e.preventDefault();

    // Final validation
    const timeFields = [
      "MinPermissionDuration",
      "MaxPermissionDuration",
    ];

    for (const field of timeFields) {
      if (
        !isValidTimeFormat(locationData[field])
      ) {
        alert(
          `${field} should be in HH:MM format`
        );
        return;
      }
    }

    try {
      setLoading(true);

      const payload = {
        locationId:
          locationData?.LocationId || null,

        latitude: parseFloat(
          locationData.latitude
        ),

        longitude: parseFloat(
          locationData.longitude
        ),

        allowedRadius: parseFloat(
          locationData.allowRadius
        ),

        isActive: locationData.isActive,

        autoDeduction:
          locationData.autoDeduction,

        MaxPermissionLimit:
          locationData.MaxPermissionLimit,

        MinPermissionDuration:
          locationData.MinPermissionDuration,

        MaxPermissionDuration:
          locationData.MaxPermissionDuration,
      };

      await insertCompanyLocation(payload);

      alert("Settings saved successfully!");

      await fetchExistingLocation();
    } catch (error) {
      console.error(error);
      alert("Failed to save settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-gray-50 p-6">
      <Breadcrumb title={'Company General'}/>
      <div className="   flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-y-auto max-h-[95vh]">
          <form onSubmit={handleSubmitLocation}>
            <div className="px-8 py-6 border-b flex items-center justify-between bg-gray-50">
             
            </div>

            <div className="p-8 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                {/* Latitude */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Latitude
                  </label>

                  <input
                    type="text"
                    name="latitude"
                    value={locationData.latitude}
                    onChange={handleLocationChange}
                    className="w-full px-5 py-3.5 border border-gray-300 rounded-2xl"
                  />
                </div>

                {/* Longitude */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Longitude
                  </label>

                  <input
                    type="text"
                    name="longitude"
                    value={locationData.longitude}
                    onChange={handleLocationChange}
                    className="w-full px-5 py-3.5 border border-gray-300 rounded-2xl"
                  />
                </div>

                {/* Radius */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Allowed Radius
                  </label>

                  <input
                    type="number"
                    name="allowRadius"
                    value={locationData.allowRadius}
                    onChange={handleLocationChange}
                    className="w-full px-5 py-3.5 border border-gray-300 rounded-2xl"
                  />
                </div>

                {/* Max Weekly */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Max Permission Limit Per Month
                  </label>

                  <input
                    type="text"
                    name="MaxPermissionLimit"
                    value={
                      locationData.MaxPermissionLimit
                    }
                    onChange={handleLocationChange}
                    placeholder=""
                    className="w-full px-5 py-3.5 border border-gray-300 rounded-2xl"
                  />

                  {errors.MaxPermissionLimit && (
                    <p className="text-red-500 text-sm mt-1">
                      {
                        errors.MaxPermissionLimit
                      }
                    </p>
                  )}
                </div>

                {/* Min Duration */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Min Permission Duration
                  </label>

                  <input
                    type="text"
                    name="MinPermissionDuration"
                    value={
                      locationData.MinPermissionDuration
                    }
                    onChange={handleLocationChange}
                    placeholder="HH:MM"
                    className="w-full px-5 py-3.5 border border-gray-300 rounded-2xl"
                  />

                  {errors.MinPermissionDuration && (
                    <p className="text-red-500 text-sm mt-1">
                      {
                        errors.MinPermissionDuration
                      }
                    </p>
                  )}
                </div>

                {/* Max Duration */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Max Permission Duration
                  </label>

                  <input
                    type="text"
                    name="MaxPermissionDuration"
                    value={
                      locationData.MaxPermissionDuration
                    }
                    onChange={handleLocationChange}
                    placeholder="HH:MM"
                    className="w-full px-5 py-3.5 border border-gray-300 rounded-2xl"
                  />

                  {errors.MaxPermissionDuration && (
                    <p className="text-red-500 text-sm mt-1">
                      {
                        errors.MaxPermissionDuration
                      }
                    </p>
                  )}
                </div>

              </div>
            </div>

            <div className="px-8 py-6 border-t bg-gray-50 flex gap-4 justify-end">
              <button
                type="submit"
                disabled={loading}
                className="px-10 py-3.5 bg-blue text-white font-semibold rounded-2xl"
              >
                {loading
                  ? "Saving..."
                  : "Save Settings"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default GeneralSettings;